module.exports = __webpack_public_path__ + "static/sheep.12ab2ac4.png";


//////////////////
// WEBPACK FOOTER
// ./src/data/sheep.png
// module id = ./src/data/sheep.png
// module chunks = 102538987983895